import SchemeBusinessService from '../services/scheme-business-service';

export const schemeBusiness = {
  namespaced: true,
  state: {
    business: null,
    businessVerificationSearchResult: null,
    lastBusinessVerificationSearchConfig: null,
    businessVerificationPageNumber: 0,
    schemeBusinesses: null,
    companyInsolvency: null,
  },
  actions: {
    get({ commit }, payload) {
      commit('setIsBusy', true, { root: true });
      commit('setBusiness', null);
      return SchemeBusinessService.get(payload.schemeId, payload.schemeBusinessId).then(
        (result) => {
          commit('setIsBusy', false, { root: true });
          commit('setBusiness', result.model);
          return Promise.resolve(result);
        },
        (error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        },
      );
    },
    updateBusinessRegistration({ commit }, payload) {
      commit('setIsBusy', true, { root: true });
      return SchemeBusinessService.updateBusinessRegistration(
        payload.schemeId,
        payload.schemeBusinessId,
        payload.businessRegistration,
      ).then(
        (result) => {
          commit('setIsBusy', false, { root: true });
          commit('setBusiness', result.model);
          return Promise.resolve(result);
        },
        (error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        },
      );
    },
    resubmit({ commit }, payload) {
      commit('setIsBusy', true, { root: true });
      return SchemeBusinessService.resubmit(payload.schemeId, payload.schemeBusinessId).then(
        (result) => {
          commit('setIsBusy', false, { root: true });
          commit('setBusiness', result.model);
          return Promise.resolve(result);
        },
        (error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        },
      );
    },
    rematch({ commit }, payload) {
      commit('setIsBusy', true, { root: true });
      return SchemeBusinessService.rematch(
        payload.schemeId,
        payload.schemeBusinessId,
        payload.tmln,
      ).then(
        (result) => {
          commit('setIsBusy', false, { root: true });
          commit('setBusinessLinkPending', {
            linkPending: null,
            tmln: null,
            trustmarkBusinessId: null,
            status: 3,
          });
          return Promise.resolve(result);
        },
        (error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        },
      );
    },
    publishtrades({ commit }, payload) {
      commit('setIsBusy', true, { root: true });
      return SchemeBusinessService.publishtrades(payload.schemeId, payload.schemeBusinessId).then(
        (result) => {
          commit('setIsBusy', false, { root: true });
          return Promise.resolve(result);
        },
        (error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        },
      );
    },
    createLodgementPortalLogin({ commit }, payload) {
      commit('setIsBusy', true, { root: true });
      return SchemeBusinessService.createLodgementPortalLogin(
        payload.schemeId,
        payload.schemeBusinessId,
        payload.email,
      ).then(
        (result) => {
          commit('setIsBusy', false, { root: true });
          return Promise.resolve(result);
        },
        (error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        },
      );
    },
    listLegacyLodgementBranches({ commit }, payload) {
      commit('setIsBusy', true, { root: true });
      return SchemeBusinessService.listLegacyLodgementBranches(
        payload.schemeId,
        payload.schemeBusinessId,
      ).then(
        (result) => {
          commit('setIsBusy', false, { root: true });
          return Promise.resolve(result);
        },
        (error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        },
      );
    },
    updateCeaseToTrade({ commit }, payload) {
      commit('setIsBusy', true, { root: true });
      return SchemeBusinessService.updateCeaseToTrade(
        payload.schemeId,
        payload.schemeBusinessId,
        payload,
      ).then(
        (result) => {
          commit('setIsBusy', false, { root: true });
          return Promise.resolve(result);
        },
        (error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        },
      );
    },
    verificationSearch({ commit }, data) {
      commit('setIsBusy', true, { root: true });
      data.type = 'standard';
      commit('setLastBusinessVerificationSearchConfig', data);
      return SchemeBusinessService.verificationSearch(data).then(
        (result) => {
          commit('setIsBusy', false, { root: true });
          commit('setBusinessVerificationSearchResult', result);
          return Promise.resolve(result);
        },
        (error) => {
          commit('setIsBusy', false, {
            root: true,
          });
          return Promise.reject(error);
        },
      );
    },
    verificationSearchAdvanced({ commit }, data) {
      commit('setIsBusy', true, { root: true });
      data.type = 'advanced';
      commit('setLastBusinessVerificationSearchConfig', data);
      return SchemeBusinessService.verificationSearchAdvanced(data).then(
        (result) => {
          commit('setIsBusy', false, { root: true });
          commit('setBusinessVerificationSearchResult', result);
          return Promise.resolve(result);
        },
        (error) => {
          commit('setIsBusy', false, {
            root: true,
          });
          return Promise.reject(error);
        },
      );
    },
    getSchemeBusinesses({ commit }, payload) {
      commit('setIsBusy', true, { root: true });
      return SchemeBusinessService.getSchemeBusinesses(payload.disputeId).then(
        (result) => {
          commit('setIsBusy', false, { root: true });
          commit('setSchemeBusinesses', result.model);
          return Promise.resolve(result);
        },
        (error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        },
      );
    },
    getCompaniesHouseInsolvency({ commit }, payload) {
      commit('setIsBusy', true, { root: true });
      commit('setCompanyInsolvency', null);
      return SchemeBusinessService.getCompaniesHouseInsolvency(
        payload.registeredCompanyNumber,
      ).then(
        (result) => {
          commit('setIsBusy', false, { root: true });
          commit('setCompanyInsolvency', result.model);
          return Promise.resolve(result);
        },
        (error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        },
      );
    },
    clearCompanyInsolvency({ commit }) {
      commit('setCompanyInsolvency', null);
    },
    async updateRegisteredCompanyNumber({ commit, dispatch }, payload) {
      commit('setIsBusy', true, { root: true });
      try {
        const result = await SchemeBusinessService.updateRegisteredCompanyNumber(payload);
        await dispatch('get', {
          schemeId: payload.schemeId,
          schemeBusinessId: payload.schemeBusinessId,
        });
        return result;
      } finally {
        commit('setIsBusy', false, { root: true });
      }
    },
  },
  mutations: {
    setBusiness(state, business) {
      state.business = business;
    },
    setBusinessLinkPending(state, newlinkPendingActioned) {
      state.business.schemeBusiness.linkPending = newlinkPendingActioned.linkPending;
      state.business.schemeBusiness.status = newlinkPendingActioned.status;
      state.business.schemeBusiness.tmln = newlinkPendingActioned.tmln;
      state.business.schemeBusiness.trustmarkBusinessId =
        newlinkPendingActioned.trustmarkBusinessId;
    },
    setBusinessActiveTradingStandardsApplication(state, newModel) {
      state.business.schemeBusiness.activeTradingStandardsApplicationReference =
        newModel.applicationReference;
    },
    setBusinessVerificationSearchResult(state, businessVerificationSearchResult) {
      state.businessVerificationSearchResult = businessVerificationSearchResult;
    },
    setLastBusinessVerificationSearchConfig(state, businessVerificationSearchResult) {
      state.lastBusinessVerificationSearchConfig = businessVerificationSearchResult;
    },
    setBusinessVerificationPageNumber(state, newPageNumber) {
      state.businessVerificationPageNumber = newPageNumber;
    },
    setSchemeBusinesses(state, newSchemeBusinesses) {
      state.schemeBusinesses = newSchemeBusinesses;
    },
    setCompanyInsolvency(state, newCompanyInsolvency) {
      state.companyInsolvency = newCompanyInsolvency;
    },
  },
};
